import React from 'react';
import FileUploader from '../file-uploader';

class AttachDocumentModal extends React.Component {

    constructor(props) {
        super(props)
        this.state = { }
    }

    componentDidMount() {
        $(`#${this.props.modalId}`).modal('show')
        $(`#${this.props.modalId}`).on('hidden.bs.modal', () => {
            this.props.modalHidden()
        })
    }

    render() {
        return (
            <div className="modal attach-document-modal" tabIndex="-1" role="dialog" aria-labelledby="attachDocumentModal"
                aria-hidden="true" id={this.props.modalId}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body">
                            <FileUploader useOriginalFilename={true} contractId={this.props.contractId} dispatch={this.props.dispatch} multiple={false} updateContract={true} contracts={this.props.contracts} toggleAddPhotoView={this.toggleAddPhotoView} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

AttachDocumentModal.defaultProps = { }
export default AttachDocumentModal;